import { render } from "./NotFoundPage.vue?vue&type=template&id=14028403"
import script from "./NotFoundPage.vue?vue&type=script&lang=js"
export * from "./NotFoundPage.vue?vue&type=script&lang=js"

import "./NotFoundPage.vue?vue&type=style&index=0&id=14028403&lang=scss"
script.render = render

export default script